// extracted by mini-css-extract-plugin
export default {"cls1":"VxES7T2VrAC2hVD9vd6K","cls2":"EkWJNDUHJ6Zovch8jk0b VxES7T2VrAC2hVD9vd6K"};